import * as React from 'react';
import { ListSearch } from './ListSearch';
import { ListReorder } from './ReorderMode';
import './ListControls.css';

interface ListSummarySearch {
  search: ListSearch;
  /** 絞り込みの欄に薄く出す、何で絞り込めるかの説明 */
  placeholder: string;
}

interface ListSummaryProps {
  reorder: ListReorder;
  /** 表に出している件数。物件一覧と同じく、絞り込んでいる間も全体の件数は添えず、この件数だけを出す */
  shownCount: number;
  /** 絞り込みの欄を置く一覧だけ渡す */
  search?: ListSummarySearch;
}

// 絞り込みの欄の左端の内側に置く虫めがねの印。探すための欄だとひと目で分かるようにする
const SearchIcon: React.FC = function () {
  return (
    <svg
      className="ListControls-search_icon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      aria-hidden="true"
    >
      <circle cx="7" cy="7" r="4.8" />
      <line x1="10.6" y1="10.6" x2="14" y2="14" />
    </svg>
  );
};

/**
 * 表のすぐ上の行。左に絞り込みの欄（絞り込みのある一覧だけ）、その右に件数を出す。
 * 並びを変えられる人が絞り込んでいる間は、件数の横に並び替えできないことを添える
 */
export const ListSummary: React.FC<ListSummaryProps> = function (props) {
  let searchInput;
  const search = props.search;
  if (search !== undefined) {
    searchInput = (
      <span className="ListControls-search_box">
        <SearchIcon />
        <input
          className="ListControls-search"
          type="search"
          aria-label={search.placeholder}
          placeholder={search.placeholder}
          value={search.search.text}
          onChange={(event) => search.search.setText(event.target.value)}
        />
      </span>
    );
  }
  let note;
  if (props.reorder.pausedByFilter) {
    note = <span className="ListControls-note">絞り込んでいる間は並び替えできません</span>;
  }
  return (
    <div className="ListControls">
      {searchInput}
      <p className="App-table_count">
        {props.shownCount} 件
        {note}
      </p>
    </div>
  );
};
